<template>
    <div class="convert-header">
        {{ header }}
    </div>
</template>

<style>
.convert-header {
    background: white;
    padding: 0.3rem 1rem;
    font-size: 1.2rem;
    font-weight: 600;
}
</style>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        header: {
            type: String
        }
    }
});
</script>
